import { ChatPersona } from "components/UI/Chat/AcxChatViewer";

export class Blurb {
    text: string;
    channel: number;
    timeInterval: number[];
    foundEddy: boolean;
    foundAdverse: boolean;
    firstWordIndex?: number;
    lastWordIndex?: number;

    constructor(
        text: string,
        channel: number,
        timeInterval: number[],
        foundEddy: boolean,
        foundAdverse: boolean,
        firstWordIndex?: number,
        lastWordIndex?: number,
    ) {
        this.text = text;
        this.channel = channel;
        this.timeInterval = timeInterval;
        this.foundEddy = foundEddy;
        this.foundAdverse = foundAdverse;
        if (firstWordIndex !== undefined) {
            this.firstWordIndex = firstWordIndex;
        }
        if (lastWordIndex !== undefined) {
            this.lastWordIndex = lastWordIndex;
        }
    }
}

export type ChatBlurb = Omit<Blurb, "timeInterval" | "channel"> & {
    from: ChatPersona;
    timestamp: string;
};
